// extracted by mini-css-extract-plugin
export default {"main":"OurGoalDetails_main__1GPvA","goalText":"OurGoalDetails_goalText__k2TuP","goalImage":"OurGoalDetails_goalImage__bPLBG","goalTitle":"OurGoalDetails_goalTitle__B8cQi"};